import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import '../../App.css';
import InputAutoComplete from '../../components/Inputs/InputAutoComplete/InputAutoComplete';
import InputData from '../../components/Inputs/InputData/InputData';
import InputSelect from '../../components/Inputs/InputSelect/InputSelect';
import InputToggle from '../../components/Inputs/InputToggle/InputToggle';
import Pagina from '../../components/Pagina/Pagina';
import api from '../../services/api';
import { getFiltroPadraoRelatorioLucroPedidos } from '../../utils/filtros';
import { gridColumn } from '../../utils/gridColumn';
import { ajustaDatas, optionsDatas } from '../../utils/utils';
import { baixarArquivoBase64 } from '../../utils/download';
import InputFiltro from '../../components/Inputs/InputFiltro/InputFiltro';
import Filtros from '../../components/Filtros/Filtros';
import InputTexto from '../../components/Inputs/InputTexto/InputTexto';
import FormikPadrao from '../../components/FormikPadrao/FormikPadrao';
import BarraBotoes from '../../components/BarraBotoes/BarraBotoes';
import TotalizadorRelatorio from '../../components/TotalizadorRelatorio/TotalizadorRelatorio';
import Tabela from '../../components/Tabela/Tabela';

function RelLucroPedidos() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [search] = useSearchParams();
  const [searchBar, setSearchBar] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [relLucroPedidos, setRelLucroPedidos] = useState([]);
  const [totalPedidos, setTotalPedidos] = useState(0);
  const [totalLucro, setTotalLucro] = useState(0);
  const [totalPorcentagem, setTotalPorcentagem] = useState(0);

  async function GetRelLucroPedidos(filtros) {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(filtros, null, 2),
    };
    let res = await api.post('/LucroPedidosReport/GetList', payload);
    let data = res.data;
    if (res.status === 200) {
      setRelLucroPedidos(data.Pedidos);
      if (data.Pedidos && Object.keys(data.Pedidos).length > 0) {
        let pedidos = 0;
        let lucro = 0;

        data.Pedidos.map(rel => (pedidos += rel.ValorTotal));
        data.Pedidos.map(rel => (lucro += rel.LucroPedido));
        let percentual = (lucro / pedidos) * 100;

        setTotalPedidos(pedidos);
        setTotalLucro(lucro);
        setTotalPorcentagem(percentual);
      } else {
        setTotalPedidos(0);
        setTotalLucro(0);
        setTotalPorcentagem(0);
      }
      setLoading(false);
    } else {
      alert('Erro ao buscar dados');
    }
  }

  useEffect(() => {
    GetRelLucroPedidos(getFiltroPadraoRelatorioLucroPedidos());
  }, []);

  useEffect(() => {
    if (search.get('filter')) {
      setShowFilters(search.get('filter') === 'true');
      GetRelLucroPedidos(getFiltroPadraoRelatorioLucroPedidos());
    }
  }, [search]);

  function handleEdit(item) {
    navigate(`/Pedidos/Editar/${item.Id}`);
  }

  const getPDF = async () => {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(relLucroPedidos, null, 2),
    };
    baixarArquivoBase64('/LucroPedidosReport/GetPDF', payload);
  };

  const getExcel = async () => {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(relLucroPedidos, null, 2),
    };
    baixarArquivoBase64('/LucroPedidosReport/GetExcel', payload);
  };

  return (
    <Pagina loading={loading}>
      <FormikPadrao
        initialValues={getFiltroPadraoRelatorioLucroPedidos()}
        onSubmit={async values => {
          await GetRelLucroPedidos(values);
        }}
      >
        <BarraBotoes
          maxWindowSize={1030}
          botoes={[
            {
              children: 'Exportar Planilha',
              onClick: getExcel,
              variant: 'verde',
            },
            {
              children: 'Exportar PDF',
              onClick: getPDF,
              variant: 'rosa',
            },
          ]}
          search={{
            placeholder: 'Procurar por pedidos',
            onChange: e => setSearchBar(e.target.value),
          }}
          showFilters={showFilters}
          setShowFilters={setShowFilters}
        />
        <FilterMenu showFilters={showFilters} setShowFilters={setShowFilters} />
        <TotalizadorRelatorio
          items={[
            {
              Titulo: 'TOTAL DE PEDIDOS',
              Valor: totalPedidos,
              type: 'money',
            },
            {
              Titulo: 'TOTAL DE LUCRO',
              Valor: totalLucro,
              type: 'money',
            },
            {
              Titulo: 'PERCENTUAL DE LUCRO',
              Valor: `${totalPorcentagem.toFixed([2])}%`,
            },
          ]}
        />
        <Tabela
          titulo={'RELATÓRIO DE LUCRO DE PEDIDOS'}
          setFunction={setRelLucroPedidos}
          data={relLucroPedidos}
          columns={[
            {
              placeholder: 'PEDIDO',
              name: 'Codigo',
              type: 'text',
            },
            {
              placeholder: 'EMPRESA',
              name: 'Empresa',
              type: 'text',
            },
            {
              placeholder: 'CLIENTE',
              name: 'Cliente',
              type: 'text',
            },
            {
              placeholder: 'DATA',
              name: 'Data',
              type: 'date',
            },
            {
              placeholder: 'CUSTO PRODUTOS',
              name: 'CustoProdutos',
              type: 'money',
            },
            {
              placeholder: 'CUSTO SERVIÇOS',
              name: 'CustoServicos',
              type: 'money',
            },
            {
              placeholder: 'CUSTO TOTAL',
              name: 'CustoTotal',
              type: 'money',
            },
            {
              placeholder: 'DESCONTOS',
              name: 'Descontos',
              type: 'money',
            },
            {
              placeholder: 'VALOR',
              name: 'ValorTotal',
              type: 'money',
            },
            {
              placeholder: 'VALOR FRETE',
              name: 'ValorFrete',
              type: 'money',
            },
            {
              placeholder: 'LUCRO PEDIDO',
              name: 'LucroPedido',
              type: 'money',
            },
          ]}
          searchBar={searchBar}
          handleEdit={handleEdit}
        />
      </FormikPadrao>
    </Pagina>
  );
}

function FilterMenu({ showFilters, setShowFilters }) {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    ajustaDatas(values.PeriodoLancamento, setFieldValue);
  }, [values.PeriodoLancamento, setFieldValue]);

  return (
    <Filtros showFilters={showFilters} setShowFilters={setShowFilters}>
      <InputFiltro
        titulo="CÓDIGO"
        id="Codigo"
        name="Codigo"
        component={InputTexto}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="CLIENTE/FORNECEDOR"
        id="Cliente"
        name="Cliente"
        component={InputAutoComplete}
        autocomplete={true}
        path={'ClienteFornecedor'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="EMPRESA"
        id="Empresa"
        name="Empresa"
        component={InputAutoComplete}
        autocomplete={true}
        path={'Empresa'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="APENAS PAGOS?"
        id="ApenasCompletamentePagos"
        name="ApenasCompletamentePagos"
        component={InputToggle}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="PERÍODO"
        id="PeriodoLancamento"
        name="PeriodoLancamento"
        component={InputSelect}
        options={optionsDatas}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="Data Inicial"
        id="DataInicial"
        name="DataInicial"
        component={InputData}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="Data Final"
        id="DataFinal"
        name="DataFinal"
        component={InputData}
        gridColumn={gridColumn.gc4}
      />
    </Filtros>
  );
}

export default RelLucroPedidos;
